import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserAvatar } from '../interfaces/IUserAvatar';
import { logout } from '../action/logout-action';

const initialState :IUserAvatar[]=[JSON.parse(window.sessionStorage.getItem("userAvatar"))]

export const UserAvatarImg = createSlice({
  name: 'userAvatar',
  initialState,
  extraReducers: (builder) => builder.addCase(logout, () => []),
  reducers: { 
    StoreUserAvatar: (state=initialState, action: PayloadAction<IUserAvatar>) => {  
          let Msg: IUserAvatar={
            userAvatar:action.payload.userAvatar,
            fileUploadProgressStatus:action.payload.fileUploadProgressStatus
          }
          return [Msg];
    },
  },
})

export const { StoreUserAvatar } = UserAvatarImg.actions
export default UserAvatarImg.reducer